import { Currency } from "@lookiero/sty-psp-locale";
import {
  CheckoutPricingProjection,
  CheckoutPricingContext,
  CheckoutPricingType,
} from "../../../projection/pricing/pricing";

const mockCheckoutPricingProjection: CheckoutPricingProjection = {
  currency: Currency.EUR,
  finalPrice: 12127,
  originalPrice: 21195,
  modifiers: [
    {
      amount: 7068,
      percentage: 35,
      type: CheckoutPricingType.DISCOUNT,
      context: CheckoutPricingContext.PROMOCODE,
      translationKey: "summary.discount",
    },
    {
      amount: 1000,
      type: CheckoutPricingType.DISCOUNT,
      context: CheckoutPricingContext.BALANCE,
      translationKey: "summary.credit",
    },
    {
      amount: 1000,
      type: CheckoutPricingType.DISCOUNT,
      context: CheckoutPricingContext.PS_FEE,
      translationKey: "summary.fee",
    },
  ],
};

export { mockCheckoutPricingProjection };
